module.exports = require('./helpers/bundle-url').getBundleURL('37CdW') + "done-circle.1ea9006c.svg";